import { observer } from "mobx-react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { ButtonWithIcon } from "components/UI/ButtonWithIcon/ButtonWithIcon";
import Badges from "components/UI/Badges/Badges";

import selectedIcon from "assets/images/selectdeadline.svg";

import AppStore from "AppStore";

import "./ModeSelection.scss";

const ModeSelection = observer(({ store, description }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Выбор режима тянет за собой запрос цены у сервера. Когда путь ни с одним
    // режимом не совпал, режим остаётся прежним — цену всё равно надо спросить.
    if (!AppStore.selectMarketStoreAndCalculatorByPath(pathname))
      store.currentCalculator.syncServerPrice();
  }, [pathname, store]);

  return (
    <div className="mode-selection">
      <div className={`mode-selection__container ${store.market.isSeo ? "other-colors" : ""}`}>
        {store.calculators.map((calculator, i) => (
          <div key={i} className={`mode-selection__wrapper ${calculator.mode.bots ? "has-price" : ""}`}>
            <ButtonWithIcon
              title={<h3>{calculator.mode.title}</h3>}
              className={`mode-selection__button ${store.selectedCalculatorIndex === i ? "active" : ""}  ${store.market.isSeo ? "other-colors" : ""}`}
              icon={store.selectedCalculatorIndex === i ? selectedIcon : ""}
              onClick={() => { store.selectCalculator(i) }}
              ariaLabel={`Выбрать режим ${calculator.mode.title}`}
              to={calculator.mode.path}
              target="_self"
            />
            {calculator.mode.bots && <Badges status="дешевле" />}
          </div>
        ))}
      </div>
      {description && <p className="mode-selection__description">{description}</p>}
    </div>
  );
});

export default ModeSelection;
